class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.recordarDondeMira();
  }

  // Demates (15/10/2026): desde que productos, resumen y kit se deslizan juntos («dm-cuerpo»), al cambiar una cantidad el
  // carrito se redibuja entero y volvía arriba de todo. Se guarda hasta dónde bajó (al deslizar y en el momento de tocar
  // algo) y se repone en el redibujado; después de agregar algo (renderContents) sí va arriba, que es donde aparece lo
  // nuevo. También se recuerda si eligió ver 6 cuotas en vez de 12.
  recordarDondeMira() {
    this.dmBajo = 0;
    const anotar = () => {
      const cuerpo = this.querySelector('.dm-cuerpo');
      if (cuerpo && cuerpo.isConnected) this.dmBajo = cuerpo.scrollTop;
    };
    this.addEventListener('scroll', (e) => {
      if (e.target.classList && e.target.classList.contains('dm-cuerpo')) this.dmBajo = e.target.scrollTop;
    }, true);
    ['pointerdown', 'click', 'keydown'].forEach((tipo) => this.addEventListener(tipo, anotar, true));
    this.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'dm-cuotas') this.dmCuotas = e.target.value;
      else anotar();
    }, true);
    new MutationObserver(() => {
      const cuerpo = this.querySelector('.dm-cuerpo');
      if (!cuerpo || cuerpo === this.dmCuerpo) return;
      this.dmCuerpo = cuerpo;
      const elegida = this.dmCuotas && cuerpo.querySelector(`#dm-cuotas-${this.dmCuotas}`);
      if (elegida) elegida.checked = true;
      if (this.dmArriba) { this.dmArriba = false; this.dmBajo = 0; return; }
      if (this.dmBajo) cuerpo.scrollTop = this.dmBajo;
    }).observe(this, { childList: true, subtree: true });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.abrirAlDia(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.abrirAlDia(cartLink);
      }
    });
  }

  // Demates (15/10/2026): el armador 3D agrega al carrito sin redibujar el cajón (cambia solo el número del ícono). Si el
  // número del ícono y lo que muestra el cajón no coinciden, se trae el carrito al día antes de abrirlo; si no, decía
  // «Tu carrito está vacío» con el mate adentro.
  abrirAlDia(triggeredBy) {
    const numero = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    const enIcono = numero ? parseInt(numero.textContent, 10) || 0 : 0;
    const enCajon = this.classList.contains('is-empty')
      ? 0
      : [...this.querySelectorAll('.cart-item .quantity__input')].reduce((n, i) => n + (parseInt(i.value, 10) || 0), 0);
    if (enIcono === enCajon || !window.fetch) return this.open(triggeredBy);

    fetch(`${(window.routes && routes.cart_url) || '/cart'}?sections=cart-drawer,cart-icon-bubble`)
      .then((r) => r.json())
      .then((secciones) => {
        this.dmArriba = true;
        this.getSectionsToRender().forEach((section) => {
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (el && secciones[section.id]) el.innerHTML = this.getSectionInnerHTML(secciones[section.id], section.selector);
        });
        this.classList.toggle('is-empty', !this.querySelector('.cart-item'));
        const velo = this.querySelector('#CartDrawer-Overlay');
        if (velo) velo.addEventListener('click', this.close.bind(this));
        this.open(triggeredBy);
      })
      .catch(() => this.open(triggeredBy));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Demates (15/10/2026): se llama después de agregar, así que el carrito ya no está vacío. Se saca la marca acá, en el
    // cajón mismo, para que ningún botón propio la deje puesta (con «is-empty» el cajón se abría en blanco, sin lo agregado).
    this.classList.remove('is-empty');
    this.dmArriba = true;
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
